import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['button'];

  connect() {
    this.onBackClick = this.onBackClick || this.handleBackClick.bind(this);
    this.setupBackButton();
  }

  disconnect() {
    if (this.hasButtonTarget && this.onBackClick) {
      this.buttonTarget.removeEventListener('click', this.onBackClick);
    }
  }

  setupBackButton() {
    const backButton = this.buttonTarget;
    if (backButton.tagName === 'BUTTON') return;

    const fallbackUrl = this.getBackButtonFallbackUrl(backButton);

    backButton.removeEventListener('click', this.onBackClick);

    if (window.history.length > 1) {
      backButton.addEventListener('click', this.onBackClick);
    } else if (fallbackUrl) {
      backButton.setAttribute('href', fallbackUrl);
    }
  }

  handleBackClick(event) {
    event.preventDefault();
    window.history.back();
  }

  getBackButtonFallbackUrl(backButton) {
    const parentUrl = backButton.dataset.parentUrl;

    if (parentUrl && parentUrl.trim() !== '') {
      return parentUrl;
    }

    return this.computeFallbackUrl(window.location.href);
  }

  computeFallbackUrl(currentUrl) {
    const urlObj = new URL(currentUrl);
    const pathname = urlObj.pathname;
    const pathSegments = pathname.split('/').filter(segment => segment.length > 0);

    if (pathSegments.length > 1) {
      const newPathname = '/' + pathSegments[0];
      return urlObj.origin + newPathname;
    }

    return urlObj.origin;
  }
}
